import { render, staticRenderFns } from "./GiftCardUploadPane.vue?vue&type=template&id=3140ae0d&scoped=true"
import script from "./GiftCardUploadPane.vue?vue&type=script&lang=js"
export * from "./GiftCardUploadPane.vue?vue&type=script&lang=js"
import style0 from "./GiftCardUploadPane.vue?vue&type=style&index=0&id=3140ae0d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3140ae0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3140ae0d')) {
      api.createRecord('3140ae0d', component.options)
    } else {
      api.reload('3140ae0d', component.options)
    }
    module.hot.accept("./GiftCardUploadPane.vue?vue&type=template&id=3140ae0d&scoped=true", function () {
      api.rerender('3140ae0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/GiftCardUploadPane.vue"
export default component.exports